(function () {
	'use strict';
	$(document).ready(function () {
		$(".lang-button").on('click', function () {
			const $langDropdown = $('.languages');
			$langDropdown.fadeToggle(300);
			$langDropdown.toggleClass('open');
			$(this).toggleClass("open");
			closeSubmenus();
		});

		const $header = document.querySelector('header.header');
		$(window).on('scroll', () => {
			$header.classList.toggle('scrolled', window.scrollY >= 120)
		});
	});
}(jQuery));
